import { APP_LOCALES, isTargetAppLocale } from '@govinity/shared-config/locales';

/** The caption language (HLS `LANGUAGE`, e.g. `es-US`) for a page locale, or null for English. */
export const getPageCaptionLanguage = (locale: string): string | null =>
  isTargetAppLocale(locale) ? APP_LOCALES[locale].captionLanguage : null;
